import { Button, Table } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Home from "./Home";
import { NavLink } from "react-router-dom";
import KwdcHeader from './LoginHeader';
import { FaRegFilePdf } from 'react-icons/fa';
import PublicSiteFooter from './PublicSiteFooter';
// import KwdcHeader from './Header';
export default function DownloadPage() {

    return (
        <>
            <KwdcHeader />



            <section className="kwdc-innerpage-about-top mb-0">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9} className="kwdc-innerpage-about-left">
                            <div className="kwdc-innerpage-about-heading">
                                <h1>Downloads</h1>
                                <p>
                                    A.P. State Kapu Welfare & Development
                                    Corporation
                                </p>
                            </div>
                        </Col>

                        <Col xxl={4} xl={4} lg={4} md={4} sm={3} xs={3} className="kwdc-about-right"></Col>
                    </Row>
                </Container>
            </section>



            {/* =======================================contact us=================================================== */}
            <section className="kwdc-contact-section">
                <Container>
                    <div className='table-responsive'>
                        <Table bordered hover className='affl-table'>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Doc 1</td>
                                    <td>Description of Document</td>
                                    <td className='text-center'><FaRegFilePdf size={20} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Doc 2</td>
                                    <td>Description of Document</td>
                                    <td className='text-center'><FaRegFilePdf size={20} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Doc 1</td>
                                    <td>Description of Document</td>
                                    <td className='text-center'><FaRegFilePdf size={20} /></td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Container>
            </section>

            <PublicSiteFooter />
        </>
    );
}







